import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../contextos/autenticacion/ContextoAutenticacion'
import LoadingSpinner from '../interfaz-usuario/carga/SpinnerCarga'
import { obtenerRutaPanelPorUsuario } from '../../utils/authRouting'

interface PublicRouteProps {
  children: React.ReactNode
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, usuario } = useAuth()
  const location = useLocation()

  // Mostrar spinner mientras se verifica la autenticación
  // Evitar cubrir la pantalla de login con el spinner: deja que la página maneje su propio estado
  if (isLoading && !location.pathname.startsWith('/login')) {
    return <LoadingSpinner />
  }

  // Si está autenticado, redirigir según el rol
  if (isAuthenticated && usuario) {
    return <Navigate to={obtenerRutaPanelPorUsuario(usuario)} replace />
  }

  return <>{children}</>
}

export default PublicRoute
